import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { Reveal, Kicker, SectionTitle } from "./motion";

const BONUS = [
  { img: "bonus-2", t: "Pack Canva Educacional Editável", p: "Modelos prontos para personalizar capas, etiquetas, certificados e materiais com a sua identidade.", v: "R$ 47,00" },
  { img: "bonus-1", t: "Guia Completo para Revender PLR", p: "Passo a passo para transformar os materiais em kits e começar a vender.", v: "R$ 37,00" },
  { img: "bonus-3", t: "Pack Artes para Divulgação", p: "Artes prontas para Instagram, WhatsApp e Marketplace.", v: "R$ 27,00" },
];

const Card = ({ b, i }) => (
  <motion.article whileHover={{ y: -8, rotate: i === 1 ? 0 : i === 0 ? -1 : 1 }} transition={{ type: "spring", stiffness: 260, damping: 18 }}
    className="group flex h-full flex-col overflow-hidden rounded-[32px] bg-white ring-1 ring-ink/10" data-testid={`bonus-card-${i}`}>
    <div className="relative aspect-square overflow-hidden bg-lilac">
      <img src={`/img/${b.img}.webp`} alt={b.t} loading="lazy" width={500} height={500}
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">Bônus {i + 1}</span>
    </div>
    <div className="flex flex-1 flex-col p-7">
      <h3 className="font-display text-xl font-extrabold leading-tight text-ink">{b.t}</h3>
      <p className="mt-2 flex-1 text-sm text-ink/70 sm:text-base">{b.p}</p>
      <p className="mt-5 text-sm"><s className="text-ink/50">De {b.v}</s> <b className="ml-1 text-mint">GRÁTIS no Premium</b></p>
    </div>
  </motion.article>
);

export const Bonus = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="bonus-section">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal>
        <Kicker>Só no Plano Premium</Kicker>
        <SectionTitle className="mt-5 max-w-3xl text-ink">E para você vender ainda mais: <span className="text-rose">3 bônus exclusivos</span></SectionTitle>
        <p className="mt-4 max-w-xl text-base text-ink/70 sm:text-lg">Ferramentas para montar, divulgar e vender seus kits mais rápido.</p>
      </Reveal>
      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {BONUS.map((b, i) => <Reveal key={b.t} delay={i * 0.08}><Card b={b} i={i} /></Reveal>)}
      </div>
      <Reveal>
        <div className="mt-8 flex flex-col items-start gap-2 rounded-[24px] bg-ink px-7 py-5 text-white sm:flex-row sm:items-center sm:justify-between" data-testid="bonus-total">
          <span className="flex items-center gap-3 font-display text-lg font-bold"><Gift className="h-6 w-6 text-sun" /> Total em bônus: <s className="text-zinc-400">R$ 111,00</s></span>
          <b className="font-display text-lg text-sun">HOJE GRÁTIS NO PREMIUM</b>
        </div>
      </Reveal>
    </div>
  </section>
);
